import React, { useMemo } from 'react'
import styled, { css } from 'styled-components'
import { fontSystem } from '@/styles/theme'
import { TextWithHTML } from '@musinsa/mwms-ds'
import { tokens } from '@musinsa/layer-tokens/desktop'

export const LABEL_WIDTH_DEFAULT = 88

interface Props {
  width?: number
  height?: number
  className?: string
  required?: boolean
  requiredColor?: string
  content?: React.ReactNode
}

function FieldLabel({ className, width, height, required, requiredColor, content }: Props) {
  const labelContent = useMemo(() => {
    if (content && typeof content === 'string') {
      return content.replace(/\n/g, '<br/>')
    }

    return content
  }, [content])

  return (
    <Label className={className} required={required} requiredColor={requiredColor} width={width} height={height}>
      <TextWithHTML content={labelContent} />
    </Label>
  )
}

const Label = styled.div<Pick<Props, 'width' | 'required' | 'height' | 'requiredColor'>>`
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-right: 16px;
  max-width: ${({ width }) => width || LABEL_WIDTH_DEFAULT}px;
  min-width: ${({ width }) => width || LABEL_WIDTH_DEFAULT}px;
  height: ${({ height }) => height || 24}px;
  word-break: keep-all;
  ${fontSystem.Body_14_medium};

  ${({ required, requiredColor }) =>
    required &&
    css`
      &:after {
        content: '*';
        display: inline-block;
        margin-left: 2px;
        padding-top: 6px;
        color: ${requiredColor || tokens.layerDesktop['fg-accent']};
      }
    `}
`

export default FieldLabel
